import React, { useState, useEffect }  from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AddInterpretation from './AddInterpretation';
import { formatDateShort, formatTime } from './utils/dateUtils';

function InterpretationPage({accessToken, interpretations, getInterpretations, loadingInterpretations, loadedInterpretations, getVideo, addInterpretation, removeInterpretation}) {

    const [keyword, setKeyword] = useState('');
    const [adding, setAdding] = useState(false);
    const [removing, setRemoving] = useState(false);
    
    useEffect(() => {
        if(!interpretations.length && !loadingInterpretations && !loadedInterpretations) {
            getInterpretations();
        }
    }, []); 

    const getTimestampText = (timestamp) => {
        return `${formatDateShort(timestamp)} ${formatTime(timestamp)}`;
    }

    const handleRemoveClick = async (videoID, language) => {
        if(window.confirm('Are you sure you want to delete this interpretation')) {
            setRemoving(true);
            await removeInterpretation(accessToken, videoID, language);            
            setRemoving(false);
        }
    }

    return (
        <div style={{marginLeft: '25px', marginRight: '25px'}}>
            <h5 style={{textAlign: 'left', marginBottom: '25px'}}>Interpretations:</h5>
            <div style={{display: 'flex', flexDirection: 'row', marginBottom: '10px'}}>
                <label style={{marginRight: '5px'}}>Search:</label>
                <input type="text" value={keyword} onChange={(e) => setKeyword(e.target.value)} />
            </div>
            {
                !loadingInterpretations && <a href="#" style={{display: 'block', textAlign: 'left', marginBottom: '20px'}} onClick={() => setAdding(!adding)}>Add Interpretation</a>
            }
            {
                adding && <AddInterpretation accessToken={accessToken} getVideo={getVideo} addInterpretation={addInterpretation} />
            }
            {
                interpretations.length ?  
                    <Table bordered hover size="sm" style={{width: '100%', margin: '0 auto'}}>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Published Date</th>
                                <th>Interpretations</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            interpretations.filter(interpretation => !keyword || interpretation.VideoTitle.toUpperCase().includes(keyword.toUpperCase()))
                                .map(interpretationItem => {
                                    const interpretationLanguages = Object.keys(interpretationItem.Interpretations);
                                    if(interpretationLanguages.length) {                                    
                                        return <tr key={interpretationItem.VideoID}>
                                            <td style={{textAlign: 'left'}}><a href={`https://www.youtube.com/v/${interpretationItem.VideoID}`} target="_blank">{interpretationItem.VideoTitle}</a></td>
                                            <td style={{textAlign: 'left'}}>{getTimestampText(interpretationItem.PublishedDate)}</td>
                                            <td style={{textAlign: 'left'}}>
                                                <Table striped hover size="sm" style={{width: '100%'}}>
                                                    <thead>            
                                                        <tr>                                            
                                                            <th>Language</th>
                                                            <th>Date</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            interpretationLanguages.map(interpretationLanguage => 
                                                                <tr key={interpretationLanguage}>
                                                                    <td><a href={interpretationItem.Interpretations[interpretationLanguage].AudioPath} target="_blank">{interpretationLanguage}</a></td>
                                                                    <td>{getTimestampText(interpretationItem.Interpretations[interpretationLanguage].Timestamp)}</td>
                                                                    <td><a href="#" onClick={() => handleRemoveClick(interpretationItem.VideoID, interpretationLanguage)}>Remove</a></td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </Table>
                                            </td>
                                        </tr>;
                                    }
                                }
                            )
                        }
                        </tbody>
                    </Table>
                : 
                loadingInterpretations ? 'Loading...' : 'There are currently no interpretations'
            }
        </div>
    );
}

export default InterpretationPage;